module.exports = __webpack_public_path__ + "img/lot_ico3.d922d274.png";